import { useEffect, useState } from "react";
import { themeSettingsProps } from "../theme";

export const REPORT_RECONCILIATION_EXPIRY_TIME_LOCAL_STORAGE_KEY =
  "ReportReconciliationExpiryTime";

export const PASSWORD_EXPIRY_SHOWN_KEY = "PasswordExpiryShown";

const useLocalStorage = (key: string, initialValue: any) => {
  const [data, setData] = useState(initialValue);

  useEffect(() => {
    const getData = window.localStorage.getItem(key);
    if (getData) {
      setData(JSON.parse(getData));
    }
  }, [key]);

  const storeData = (updateValue: any | themeSettingsProps) => {
    setData(updateValue);
    window.localStorage.setItem(key, JSON.stringify(updateValue));
  };

  return { data, storeData };
};

export default useLocalStorage;

export const localStore = {
  set(key: any, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  get(key: any) {
    const stored = localStorage.getItem(key);
    return !stored || stored === "undefined" ? undefined : JSON.parse(stored);
  },
  remove(key: any) {
    localStorage.removeItem(key);
  },
};
